import React, { useState } from "react";
import PaymentModal from "components/common/Modals/PaymentModal";

const ChatMessageContent = ({ message = "", chatData = {}, isSender = false }) => {
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  const handleInvoiceClick = () => {
    setShowPaymentModal(true);
  };

  // If there's invoice data, render the invoice card
  if (chatData.invoice) {

    return (
      <>
        <div
          className="card invoice-card shadow-sm"
          style={{
            cursor: "pointer",
            border: chatData.ispaid ? "2px solid #28a745" : "2px solid #007bff",
            borderRadius: "12px",
            maxWidth: "320px",
            transition: "all 0.3s ease",
            background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
          }}
          onClick={handleInvoiceClick}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-3px)";
            e.currentTarget.style.boxShadow = chatData.ispaid 
              ? "0 6px 20px rgba(40,167,69,0.25)" 
              : "0 6px 20px rgba(0,123,255,0.25)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
          }}
        >
          <div className="card-body p-4">
            <div className="d-flex align-items-center justify-content-between mb-3">
              <div className="d-flex align-items-center">
                <div className={`rounded-circle p-2 me-3 ${chatData.ispaid ? 'bg-success' : 'bg-primary'}`} style={{ width: '40px', height: '40px' }}>
                  <i
                    className={`fas ${chatData.ispaid ? 'fa-check-circle' : 'fa-file-invoice-dollar'} text-white`}
                    style={{ fontSize: "1.1rem" }}
                  ></i>
                </div>
                <div>
                  <span className={`fw-bold ${chatData.ispaid ? 'text-success' : 'text-primary'}`}>
                    {isSender ? "Payment Request Sent" : "Payment Request"}
                  </span>
                  <div className="small text-muted">
                    Ref: #{chatData.invoice}
                  </div>
                </div>
              </div>
              
              {chatData.ispaid && (
                <div className="badge bg-success-subtle text-success border border-success-subtle px-3 py-2">
                  <i className="fas fa-check me-1"></i>
                  Paid
                </div>
              )}
            </div>

            {message && (
              <div className="mb-3 p-3 bg-light rounded-3">
                <small className="text-muted d-block mb-1">Description:</small>
                <div className="fw-medium text-dark">
                  {message}
                </div>
              </div>
            )}

            <div className="d-flex align-items-center justify-content-between">
              <div>
                <small className="text-muted d-block">Amount</small>
                <div className="h4 mb-0 fw-bold" style={{ color: chatData.ispaid ? '#28a745' : '#007bff' }}>
                  <span style={{ fontSize: "1.2rem" }}>€</span>
                  {chatData.invoiceamount}
                </div>
              </div>

              <div className="text-end">
                {isSender ? (
                  <button 
                    className={`btn ${chatData.ispaid ? 'btn-outline-success' : 'btn-outline-warning'} btn-sm px-3`} 
                    disabled
                  >
                    <i className={`fas ${chatData.ispaid ? 'fa-check-circle' : 'fa-clock'} me-1`}></i>
                    {chatData.ispaid ? "Payment Received" : "Awaiting Payment"}
                  </button>
                ) : (
                  chatData.ispaid ? 
                    <button className="btn btn-success btn-sm px-3" disabled>
                      <i className="fas fa-check-circle me-1"></i>
                      Payment Complete
                    </button>
                  : <button className="btn btn-primary btn-sm px-3">
                      <i className="fas fa-credit-card me-1"></i>
                      Pay Now
                    </button>
                )}
              </div>
            </div>

            {!chatData.ispaid && (
              <div className="mt-3 pt-3 border-top">
                <small className="text-muted d-flex align-items-center">
                  <i className="fas fa-info-circle me-1"></i>
                  {isSender ? "Click to view payment details" : "Click to proceed with payment"}
                </small>
              </div>
            )}
          </div>
        </div>

        {showPaymentModal && (
          <PaymentModal
            invoiceid={chatData.invoice}
            amount={chatData.invoiceamount}
            isPaid={chatData.ispaid}
            isSender={isSender}
            onClose={() => setShowPaymentModal(false)}
          />
        )}
        
      </>
    );
  } else {
    const modifyMessage = (msg = "") => {
      const urlPattern =
        /(?:(https?:\/\/|www\.)?([a-zA-Z0-9.-]+)(\.[a-z]{2,})(\/\S*)?)/g;

      //add tld here for validation
      const validTlds = [
        "com",
        "ai",
        "net",
        "org",
        "io",
        "gov",
        "edu",
        "us",
        "co",
        "dev",
      ]; // Add more valid TLDs as needed

      return msg.replace(urlPattern, (match, protocol, domain, tld, path) => {
        const tldWithoutDot = tld.slice(1).toLowerCase(); // Remove the dot from the TLD and convert to lowercase
        if (!validTlds.includes(tldWithoutDot)) {
          return match; // If TLD is not valid, return the original match
        }

        const hyperlink = `${protocol ? protocol : "https://"}${domain}${tld}${
          path ? path : ""
        }`;

        // Return the link
        return `<a href="${hyperlink}" target="_blank" rel="noopener noreferrer">${domain}${tld}</a>`;
      });
    };

    return <p dangerouslySetInnerHTML={{ __html: modifyMessage(message) }}></p>;

  };

  
};

export default ChatMessageContent;
